module.exports = __webpack_public_path__ + "img/maldives.7e2c43c.webp";